<template lang="pug">
.call-to-action(:class="[inScroller && 'fixed-width', size && 'size-'+size]")
  DynamicMedia(:config="background" :widths="inScroller ? [308] : [380, 521, 768, 880, 1284, 1960]")
  .title(v-if="title") {{ __(title, 'auto') }}
  .subtitle(v-if="subtitle") {{ __(subtitle, 'auto') }}
  Links.cta-links(:links="filteredLinks")
</template>
<script setup lang="ts">
import { computed, inject } from 'vue'

const inScroller = inject<boolean>('inScroller', false)

type Link = {
  text?: string | null,
  url?: string | null,
  ariaLabel?: string | null,
}

const props = withDefaults(defineProps<{
  background?: Record<string, unknown>,
  title?: string,
  subtitle?: string,
  size?: string | null,
  links?: Link[],
}>(), {
  background : () => ({}),
  title      : '',
  subtitle   : '',
  size       : null,
  links      : () => [],
})

const filteredLinks = computed<Link[]>(() => {
  return props.links?.filter(link => link.url)
})
</script>

<style lang="scss" scoped>
.call-to-action.fixed-width {
  width: 308px;
  margin-right: $space-s;
  flex-shrink: 0;
  flex-grow: 0;

  &.size-medium {
    width: 250px;
    @include mobile(){
      width: 145px;
    }
  }
}

.title {
  font-family: $font-condensed;
  font-weight: bold;
  font-size: $size-s;
  margin: $space-xxs 0;
  color: $color-black-light;
  background: inherit;

  @include not-mobile(){
    font-size: $size-m;
    margin: $space-s 0 $space-xxs 0;
  }
}

.subtitle {
  color: $color-black-light;
  font-size: $size-s;
  background: inherit;
}

.cta-links {
  margin-top: $space-xxs;
  background: inherit;
  @include not-mobile(){
    margin-top: $space-xs;
    background: inherit;
  }
}

</style>
